import { render, staticRenderFns } from "./infinite-tree.vue?vue&type=template&id=920a5610&"
import script from "./infinite-tree.vue?vue&type=script&lang=js&"
export * from "./infinite-tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports